export const CONSENT_COOKIE_NAME = 'has_approved_cookie_policy';
export const QFA_COOKIE_NAME = 'qfa-upvotes';
